module.exports = __webpack_public_path__ + "img/iconDocuments.37fbce45.svg";